import React, { useState, useEffect } from "react";
import { holdingsTable } from "../../utils/API/holdingsTable";
import CustomTable from "../organisms/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import AcceptPopUp from "../molecules/AcceptPopUp";
import RetireDailogBox from "../molecules/RetireDailogBox";
import ListPopUp from "../molecules/ListPopUp";
import { useNavigate } from "react-router-dom";
import Button from "../atoms/Button";
import { Skeleton } from "antd";
import SearchBar from "../atoms/SearchButton";
import FilterBox from "../molecules/FilterBoxPage";
import { ReactComponent as Filter } from "../svgs/filter.svg";
import Pagination from "../atoms/Pagination";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";

const ActionButtons = ({ listButtonHandler, retireButtonHandler }) => {
  const { userType } = useSelector((state) => state.authReducer);
  return (
    <div>
      {(userType === "seller" || userType === "trader") && (
        <Button
          color={"blue"}
          varient={"secondary"}
          onClick={listButtonHandler}
          className={"text-white px-7 rounded-md text-[9px] py-1.5 font-bold"}
        >
          List
        </Button>
      )}

      {userType === "buyer" && (
        <Button
          color={"blue"}
          varient={"secondary"}
          onClick={retireButtonHandler}
          className={"text-white px-7 rounded-md text-[9px] py-1.5 font-bold"}
        >
          Retire
        </Button>
      )}
    </div>
  );
};

const HoldingsPage = ({ showCompletePage = true }) => {
  const dispatch = useDispatch();
  const [holdingsData, setHoldingsData] = useState(null);
  const { userType } = useSelector((state) => state.authReducer);
  const [isRetireDialogOpen, setRetireDialogOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isRetireAcceptOpen, setRetireAcceptOpen] = useState(false);
  const [isListDailogOpen, setListDailogOpen] = useState(false);
  const [isListAcceptOpen, setListAcceptOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const [searchItem, setSearchItem] = useState("");
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedToken, setSelectedToken] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });

  const headerData = [
    "Project Name",
    "Project ID",
    "Category",
    "No. of credits",
    "Token Type",
    "Registry",
    "Action",
  ];
  const pageSize = 10;

  const transformData = (originalData) => {
    return originalData.paginatedData.map((project) => {
      const projectId = project.project._id;
      const userId = project.userData.userId;
      const isListed = project.isListed;
      return [
        <p
          className="text-sm cursor-pointer"
          onClick={() =>
            navigate(`/project/${project.project._id}`, {
              state: { fromProjectsPage: true },
            })
          }
          // onClick={() => {
          //   if (userType === 'buyer' || userType === 'trader') {
          //     navigate(
          //       `/project-details?projectId=${projectId}&userId=${userId}&inquire=${isListed}`
          //     )
          //   } else {
          //     navigate(`/project/${project.project._id}`, { state: { fromProjectsPage: true }})
          //   }
          // }}
        >
          {project.project.projectName}
        </p>,
        project.project.projectId,
        project.project.categoryDetails.categoryName,
        project.availableCredits,
        project.project.tokenType,
        project.project.registryDetails.registryName,
        <ActionButtons
          listButtonHandler={() => {
            handleListClick(project);
          }}
          retireButtonHandler={() => {
            handleRetireClick(project);
          }}
        />,
      ];
    });
  };

  const fetchProjectData = async () => {
    setIsLoading(true);
    try {
      const response = await holdingsTable(
        {
          filterData: filterData,
          page: currentPage,
          pageSize: pageSize,
          searchQuery: searchItem,
        },
        dispatch
      );
      if (response.success) {
        const transformedData = transformData(response.data);
        setHoldingsData(transformedData);

        setPagination({
          totalItems: response.data.totalDocs,
          totalPages: response.data.totalPages,
        });
      } else {
        toast.error(response.message || "Failed to fetch data");
      }
    } catch (err) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProjectData();
  }, [filterData, currentPage, searchItem]);

  const navigate = useNavigate();

  const handleRetireClick = (rowData) => {
    setSelectedRowData({
      "Project Name": rowData.project.projectName,
      "Project Id": rowData.project._id,
      Category: rowData.project.categoryDetails.categoryName,
      "Number Of Credits": rowData.availableCredits,
      "Token Type": rowData.project.tokenType,
      Registry: rowData.registry,
    });
    setRetireDialogOpen(true);
  };

  const handleListClick = (rowData) => {
    setSelectedRowData({
      "Project Name": rowData.project.projectName,
      "Number Of Credits": rowData.availableCredits,
      "Token Type": rowData.project.tokenType,
      "Project Id": rowData.project._id,
    });
    setListDailogOpen(true);
  };
  const handleRetireDialogCancel = () => {
    setRetireDialogOpen(false);
  };

  const handleRetireDialogOk = () => {
    setRetireDialogOpen(false);
    setRetireAcceptOpen(true);
  };

  const handleListDailogOk = () => {
    setListDailogOpen(false);
    setListAcceptOpen(true);
    fetchProjectData();
  };

  const handleRetireAcceptCancel = () => {
    setRetireAcceptOpen(false);
  };

  const handleOnCancel = () => {
    setListDailogOpen(false);
  };

  const handleListAcceptCancel = () => {
    setListAcceptOpen(false);
  };

  const handleListNotOk = () => {
    navigate("/");
  };

  const handleRetireAcceptOk = () => {
    setRetireAcceptOpen(false);
    navigate("/retirements");
  };

  const handleListAcceptOk = () => {
    setListAcceptOpen(false);
    navigate("/my-bids");
  };

  const handleSearch = () => {
    // console.log(searchItem);
  };

  const handleRegistryCheck = (e) => {
    {
      const selectedValue = e.target.value;
      setSelectedRegistry(selectedValue);
    }
  };

  const handleFilterButtonClick = () => {
    setFilterDialogOpen(true);
  };

  const handleFilterDialogClose = () => {
    setSelectedRegistry(null);
    setSelectedCategory("");
    setSelectedToken("");
    setFilterData(null);
    setFilterDialogOpen(false);
  };

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false);
    setFilterData({
      categoryId: selectedCategory,
      registries: selectedRegistry ? [selectedRegistry] : null,
      tokenType: selectedToken,
    });
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;
    setSelectedCategory(selectedCategory);
  };

  const handleTokenChange = (event) => {
    const selectedToken = event.target.value;
    setSelectedToken(selectedToken);
  };

  return (
    <>
      {showCompletePage ? (
        <div className="bg-gray-100 h-full w-full p-6">
          <div className="text-2xl font-bold mb-6">Your Holdings</div>

          <div className="w-full mt-8 h-[calc(90vh-2.4rem)] bg-white rounded-3xl shadow-formShadow flex flex-col">
            <div className="flex justify-between pt-5 pb-12">
              <div className="w-80 border-2 border-grey-800 rounded-lg mx-5 mb-5">
                <SearchBar
                  onSearch={handleSearch}
                  searchItem={searchItem}
                  setSearchItem={setSearchItem}
                  variant="secondaryxl"
                  className="text-black"
                  borderColor="border-none"
                  placeholderColor="black"
                  inputBackground="white"
                  svgStrokeColor="black"
                  inputWidth="72"
                  inputHeight="8"
                />
              </div>

              <div className="pr-7 ">
                <Button
                  className="flex justify-center items-center gap-x-2 px-2  py-2 h-fit"
                  borderColor={"gray"}
                  varient={"secondary"}
                  onClick={handleFilterButtonClick}
                >
                  <Filter className="w-4 h-4" />
                  <span>Filter</span>
                </Button>
              </div>
            </div>
            <div className="flex-grow overflow-y-auto">
              {isLoading ? (
                <>
                  <CustomTable data={[]} headerData={headerData} />
                  <div className="flex flex-col gap-y-4 p-4">
                    <Skeleton.Button block={true} active={true} />
                    <Skeleton.Button block={true} active={true} />
                    <Skeleton.Button block={true} active={true} />
                    <Skeleton.Button block={true} active={true} />
                  </div>
                </>
              ) : (
                <CustomTable
                  data={
                    Array.isArray(holdingsData)
                      ? holdingsData.map((holding) => Object.values(holding))
                      : []
                  }
                  headerData={headerData}
                />
              )}
            </div>
            {pagination.totalPages > 1 && (
              <div className="pb-4 px-3">
                <Pagination
                  current={currentPage}
                  total={pagination.totalItems}
                  pageSize={pageSize}
                  setCurrentPage={(page) => setSearchParams({ page })}
                />
              </div>
            )}
          </div>
          <RetireDailogBox
            open={isRetireDialogOpen}
            onCancel={handleRetireDialogCancel}
            onOk={handleRetireDialogOk}
            selectedRowData={selectedRowData}
            selectedColumns={[
              "Project Name",
              "Number Of Credits",
              "Token Type",
            ]}
          />
          <AcceptPopUp
            open={isRetireAcceptOpen}
            onCancel={handleRetireAcceptCancel}
            onOk={handleRetireAcceptOk}
            notOk={handleRetireAcceptCancel}
            isRequiredColor="green"
            title="Credit Retirement Request Initiated!!!"
            statusType="Retirement"
            okButtonText="Go to Retirement"
            cancelButtonText="Go Back"
          />

          <ListPopUp
            open={isListDailogOpen}
            onCancel={handleOnCancel}
            selectedRowData={selectedRowData}
            onListPopUpOk={handleListDailogOk}
            selectedColumns={[
              "Project Name",
              "Number Of Credits",
              "Token Type",
            ]}
          />
          <AcceptPopUp
            open={isListAcceptOpen}
            onCancel={handleListAcceptCancel}
            onOk={handleListAcceptOk}
            notOk={handleListNotOk}
            title="Project Listed Successfully!!!"
            isRequiredColor="green"
            statusType={
              <span>
                Check the status in <span className="font-bold"> My Bids </span>{" "}
                Tab
              </span>
            }
            okButtonText="Go to My bids"
            width={400}
            cancelButtonText="Home"
          />

          {isFilterDialogOpen && (
            <FilterBox
              open={isFilterDialogOpen}
              onCancel={handleFilterDialogClose}
              onOk={handleFilterDialogSubmit}
              page="holdings"
              selectedRegistry={selectedRegistry}
              onCheckRegistry={handleRegistryCheck}
              selectedCategory={selectedCategory}
              onSelectCategory={handleCategoryChange}
              selectedToken={selectedToken}
              onSelectToken={handleTokenChange}
            />
          )}
        </div>
      ) : (
        <CustomTable
          data={
            Array.isArray(holdingsData)
              ? holdingsData.map((holding) => Object.values(holding))
              : []
          }
          headerData={headerData}
        />
      )}
    </>
  );
};

export default HoldingsPage;
